import React from 'react';
import RightLeaf from 'assets/images/right-leaf';
import LeftLeaf from 'assets/images/left-leaf';
import './styles.scss';

const HostBanner = ({ hostDetails = {} }) => {
  const { name, imageUrl, title } = hostDetails || {};

  const hostImageStyle = {
    background: `url(${imageUrl}) no-repeat`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  return (
    <div className="host-background">
      <div className="host-details">
        <p className="name">{name}</p>
        <p className="title">{title}</p>
      </div>

      {imageUrl && (
        <div className="host-image-wrapper">
          <img id="left-leaf" src={LeftLeaf} />
          <div className="host-image" style={hostImageStyle} />
          <img id="right-leaf" src={RightLeaf} />
        </div>
      )}
    </div>
  );
};

export default HostBanner;
